import { MobileMenuContext } from "common-components/MobileMenuContext";
import { useContext } from "react";

export const useMobileMenu = () => {
  const context = useContext(MobileMenuContext);
  if (!context) {
    throw new Error('useMobileMenu must be used within MobileMenuProvider');
  }
  return context;
};
